import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common/index';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/index';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import ErasmusUniversitiesTable from './ErasmusUniversitiesTable';
import {
  useDeleteErasmusUniversityMutation,
  useGetErasmusUniversitiesQuery,
  useSaveErasmusUniversityMutation,
} from '../../../../../redux/services/erasmusUniversities';
import UniversityModal from './ErasmusUniversitiesEdit/UniversityModal/UniversityModal';
import { isNull } from 'lodash';

const ErasmusUniversitiesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [universityInPreviewId, setuniversityInPreviewId] = useState(null);

  const {
    data: erasmusUniversities,
    isLoading,
    refetch,
  } = useGetErasmusUniversitiesQuery();

  const [deleteErasmusUniversities, { isSuccess: isDeleteSuccess }] =
    useDeleteErasmusUniversityMutation();

  const [saveErasmusUniversities, { isSuccess: isSaveSuccess }] =
    useSaveErasmusUniversityMutation();

  const { saveSuccess, deleteSuccess } = useToastMessages();

  useEffect(() => {
    if (isDeleteSuccess) {
      deleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      refetch();
    }
  }, [isSaveSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Správa univerzít')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Nová univerzita')}
        createUrl={routes.cmsErasmusUniversityCreate}
        permissionsBasic={'erasmus-universities'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <ErasmusUniversitiesTable
            erasmusUniversities={erasmusUniversities}
            onDelete={(record) => deleteErasmusUniversities(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsErasmusUniversityEdit}/${record.id}`)
            }
            onPreviewClick={(record) => setuniversityInPreviewId(record.id)}
            onDataChanged={refetch}
          />
        </CollapseBlock>
      </div>
      {!isNull(universityInPreviewId) && (
        <UniversityModal
          visible
          variant="modal"
          id={universityInPreviewId}
          toggleModal={() => setuniversityInPreviewId(null)}
          title={t('Detail univerzity')}
        />
      )}
    </>
  );
};

export default ErasmusUniversitiesPage;
